<template>
    <!--  style="height: calc(100vh - 121px)"-->
    <div>
        <div>
            <el-input style="width: 200px" placeholder="请输入手机号" suffix-icon="el-icon-search"
                      v-model="username"></el-input>
            <el-input style="width: 200px" placeholder="请输入邮箱" suffix-icon="el-icon-message" class="ml-5"
                      v-model="email"></el-input>
            <el-input style="width: 200px" placeholder="请输入地址" suffix-icon="el-icon-position" class="ml-5"
                      v-model="address"></el-input>
            <el-button class="ml-5" type="primary" @click="load">搜索</el-button>
            <el-button type="warning" @click="reset">重置</el-button>
        </div>

        <div style="margin: 10px 0">
            <el-button type="primary" @click="handleAdd">新增 <i class="el-icon-circle-plus-outline"></i></el-button>
            <el-popconfirm
                class="ml-5"
                confirm-button-text='确定'
                cancel-button-text='我再想想'
                icon="el-icon-info"
                icon-color="red"
                title="您确定批量删除这些数据吗？"
                @confirm="delBatch"
            >
                <el-button type="danger" slot="reference" v-if="false">批量删除 <i class="el-icon-remove-outline"></i>
                </el-button>
            </el-popconfirm>
            <el-upload action="http://localhost:9090/user/import" :show-file-list="false" accept="xlsx"
                       :on-success="handleExcelImportSuccess" style="display: inline-block">
                <el-button type="primary" class="ml-5" v-if="false">导入 <i class="el-icon-bottom"></i></el-button>
            </el-upload>
            <el-button type="primary" @click="exp" class="ml-5" v-if="false">导出 <i class="el-icon-top"></i></el-button>
        </div>

        <el-table :data="tableData" border stripe :header-cell-class-name="'headerBg'"
                  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" fixed></el-table-column>
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="username" label="用户名" width="140"></el-table-column>
            <el-table-column prop="role" label="角色" width="120"></el-table-column>
            <el-table-column prop="nickname" label="昵称" width="150"></el-table-column>
            <el-table-column prop="email" label="邮箱"></el-table-column>

            <el-table-column prop="address" label="地址"></el-table-column>
            <el-table-column prop="createTime" label="注册时间"  :formatter="dataFormat"></el-table-column>
            <el-table-column prop="mark" label="备注"  ></el-table-column>
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-button type="success" @click="handleEdit(scope.row)">编辑 <i class="el-icon-edit"></i></el-button>
                    <el-popconfirm
                        class="ml-5"
                        confirm-button-text='确定'
                        cancel-button-text='我再想想'
                        icon="el-icon-info"
                        icon-color="red"
                        title="您确定删除吗？"
                        @confirm="del(scope.row.id)"
                    >
                        <el-button type="danger" slot="reference">删除 <i class="el-icon-remove-outline"></i></el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <div style="padding: 10px 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[2, 5, 10, 20]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <el-dialog title="用户信息" :visible.sync="dialogFormVisible" width="30%">
            <el-form label-width="80px" size="small">
                <el-form-item label="用户名">
                    <el-input v-model="form.username" :disabled="is_add" placeholder="请输入11位手机号码"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="角色">
                    <el-select clearable v-model="form.role" placeholder="请选择角色" style="width: 100%">
                        <el-option v-for="item in roles" :key="item.name" :label="item.name"
                                   :value="item.flag"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="昵称">
                    <el-input v-model="form.nickname" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="form.email" autocomplete="off"></el-input>
                </el-form-item>

                <el-form-item label="地址">
                    <el-input v-model="form.address" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="form.mark" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <span v-if="!is_add" style="margin-left: 30px;color: red">密码默认123456</span>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </div>

        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "User",
    data() {
        return {
            is_add: false,
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            username: "",
            email: "",
            address: "",
            form: {},
            dialogFormVisible: false,
            multipleSelection: [],
            roles: []
        }
    },
    created() {
        this.load()
    },
    methods: {
        load() {
            this.request.get("/user/page", {
                params: {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    username: this.username,
                    email: this.email,
                    address: this.address,
                }
            }).then(res => {
                console.log(res)
                this.tableData = res.data.records
                this.total = res.data.total

            })

            this.request.get("/role").then(res => {
                this.roles = res.data
            })
        },

        save() {
            console.log(this.is_add)
            let url
            if (this.is_add) {
                url = "/user/update";

            } else {

                url = "/user";
            }
            console.log(this.form)
            if (this.form.role == null || this.form.role == "") {
                this.$message.error("请指定一个角色")
                return
            }

            this.request.post(url, this.form).then(res => {
                if (res.code === '200') {
                    this.$message.success("保存成功")
                    this.dialogFormVisible = false
                    this.load()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        handleAdd() {
            this.is_add = false
            this.dialogFormVisible = true
            this.form = {}
        },
        handleEdit(row) {
            this.is_add = true
            this.form = JSON.parse(JSON.stringify(row))
            this.dialogFormVisible = true
        },
        del(id) {
            this.request.delete("/user/" + id).then(res => {
                if (res.code === '200') {
                    this.$message.success("删除成功")
                    this.load()
                } else {
                    this.$message.error("删除失败")
                }
            })
        },
        handleSelectionChange(val) {
            console.log(val)
            this.multipleSelection = val
        },
        delBatch() {
            let ids = this.multipleSelection.map(v => v.id)  // [{}, {}, {}] => [1,2,3]
            this.request.post("/user/del/batch", ids).then(res => {
                if (res.code === '200') {
                    this.$message.success("批量删除成功")
                    this.load()
                } else {
                    this.$message.error("批量删除失败")
                }
            })
        },
        reset() {
            this.username = ""
            this.email = ""
            this.address = ""
            this.load()
        },
        handleSizeChange(pageSize) {
            console.log(pageSize)
            this.pageSize = pageSize
            this.load()
        },
        handleCurrentChange(pageNum) {
            console.log(pageNum)
            this.pageNum = pageNum
            this.load()
        },
        exp() {
            window.open("http://localhost:9090/user/export")
        },
        handleExcelImportSuccess() {
            this.$message.success("导入成功")
            this.load()
        },
        dataFormat(value) {
            console.log(value)
            let v = value.createTime
            let year = v.substr(0, 4);
            let month = v.substr(5, 2)
            let day = v.substr(8, 2)
            let hour = v.substr(11, 2)
            let min = v.substr(14, 2)
            let second = v.substr(17, 2)
            return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + second
            return year + "-" + month + "-" + day
        }
    }
}
</script>


<style>
.headerBg {
    background: #eee !important;
}
</style>
